import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { KibSparklesIcon } from '@chewy/kib-icons-react'

import styles from './AgentStreamingLoading.module.scss'

const ICON_SIZE = 20

export interface AgentStreamingLoadingProps {
  /** When set, shows this text (e.g. "Searching...") to the right of the icon; otherwise icon only */
  streamingIntermediateText: string | null
}

export const AgentStreamingLoading: FC<AgentStreamingLoadingProps> = ({
  streamingIntermediateText,
}) => {
  const { t } = useTranslation('Agent')

  return (
    <div className={styles.container} data-testid="agent-streaming-loading">
      <KibSparklesIcon
        aria-hidden
        className={styles.icon}
        height={ICON_SIZE}
        width={ICON_SIZE}
      />

      <span className={styles.intermediateText}>
        {streamingIntermediateText || t('Agent:DEFAULT_STREAMING_LOADING_TEXT')}
      </span>
    </div>
  )
}

export default AgentStreamingLoading
